import React from "react";
import { IoChevronDown } from "react-icons/io5";
import filterIcon from "../../assets/icons/filterone.svg";
import UploadIcon from "../../assets/icons/plus.svg";
import Add from "../../assets/icons/addCategoryBtn.svg";
import Plus from "../../assets/icons/plusprimary.svg";
import SyncIcon from "../../assets/icons/Retry.png";
import styles from "./Button.module.css";

export function Button({
  className = "",
  label,
  icon,
  btnColor = "primary",
  isEnabled = true,
  onClick,
  type = "button",
}) {
  const colorClass =
    btnColor === "secondary" ? styles.secondary : styles.primary;
  return (
    <button
      type={type}
      className={`${styles.baseButton} ${colorClass} ${className}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      {icon && icon} {label}
    </button>
  );
}

export function AddButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Add"
      btnColor="primary"
      className={styles.addButton}
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function CancelButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Cancel"
      btnColor="secondary"
      className={styles.cancelButton}
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function ContinueButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Continue"
      btnColor="primary"
      className={styles.continueButton}
      type="submit"
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function ProceedButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Proceed"
      btnColor="primary"
      className={styles.proceedButton}
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function FinishButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Finish"
      btnColor="primary"
      className={styles.proceedButton}
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function SubmitMapButton({ onClick, isEnabled = true }) {
  return (
    <Button
      label="Submit Mapping"
      btnColor="primary"
      className={styles.submapButton}
      isEnabled={isEnabled}
      onClick={onClick}
    />
  );
}

export function UploadButton({ label = "Upload", onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.uploadButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      <img src={UploadIcon} alt="Upload" className={styles.icon} />
      <span className={styles.text}>{label}</span>
    </button>
  );
}

export const BackArrowButton = ({
  onClick,
  className = "",
  isEnabled = true,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!isEnabled}
    className={`${styles.backArrow} ${className}`}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="M15 18L9 12L15 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </button>
);

export const CloseButton = ({ onClick, className = "", isEnabled = true }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!isEnabled}
    className={`${styles.closeButton} ${className}`}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="M18 6L6 18M6 6L18 18" strokeLinecap="round" />
    </svg>
  </button>
);

export const DropdownIcon = ({ onClick, className = "", isEnabled = true }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!isEnabled}
    className={`${styles.dropdownButton} ${className}`}
  >
    <IoChevronDown />
  </button>
);

export const FilterIcon = ({ onClick, className = "", isEnabled = true }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!isEnabled}
    className={`${styles.filterButton} ${className}`}
  >
    <img src={filterIcon} alt="Filter" />
  </button>
);

export function AddregButton({
  label = "Add Register",
  onClick,
  isEnabled = true,
}) {
  return (
    <button
      type="button"
      className={`${styles.primary} ${styles.addregButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      <img src={Add} alt="add" className={styles.addIcon1} />
      <span className={styles.text}>{label}</span>
    </button>
  );
}

export function AddRegisterButton({
  label = "Add Register",
  onClick,
  isEnabled = true,
}) {
  return (
    <button
      type="button"
      className={styles.AddRegisterButton}
      disabled={!isEnabled}
      onClick={onClick}
    >
      <img src={Plus} alt="add" className={styles.addIcon} />
      {label}
    </button>
  );
}

export function SyncButton({ label = "Sync Data", onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={styles.syncButton}
      onClick={onClick}
      disabled={!isEnabled}
    >
      <img src={SyncIcon} alt="Sync" className={styles.addIcon} />
      {label}
    </button>
  );
}

export function UploadFileButton({
  label = "Upload",
  onClick,
  isEnabled = true,
}) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.uploadButton}`}
      onClick={onClick}
      disabled={!isEnabled}
    >
      <img src={Plus} alt="add" className={styles.icon} />
      <span className={styles.text}>{label}</span>
    </button>
  );
}
